import React from 'react';
import { DangerIcon } from 'components/common/icons';
import { BaseAlert } from './baseAlert';
import { alertClasses, alertTypes } from '../constants';

export const ErrorAlert = props => (
  <BaseAlert
    {...props}
    icon={DangerIcon}
    className={alertClasses[alertTypes.ERROR]}
  />
);

export default ErrorAlert;
